export default {
      id: "salaire-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#salaire-usage",
      toString: function () {
        return this.url;
      }
    }